import { LocalizedText } from '@mews/framework';
import { TextKey, RouteName } from '@mews-commander/enums';
import { Stack, Typography, Button } from '@optimus-web/core';
import { CommanderThunkAction, WithEnterpriseId } from '@mews-commander/types';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { navigateInBaseModal } from '../../app/actions/common';

interface NotFoundProps {
    enterpriseId: string;
}

export const ConfigurationNotFound = ({ enterpriseId }: NotFoundProps) => {
    const dispatch = useCommanderThunkDispatch();

    const handleGoToMarketplace = () => {
        dispatch(showMarketplace({ enterpriseId }));
    };

    return (
        <Stack vertical spacing="300">
            <Typography textStyle="titleSmall" as="p">
                <LocalizedText textKey={TextKey.TextMessagingSubscriptionCallToAction} />
            </Typography>
            <Stack>
                <Button
                    data-test-id="go-to-marketplace"
                    onClick={handleGoToMarketplace}
                    size="medium"
                    type="button"
                    variant="primary"
                    wide={false}
                >
                    <LocalizedText textKey={TextKey.GoToMarketplace} />
                </Button>
            </Stack>
        </Stack>
    );
};

const showMarketplace =
    ({ enterpriseId }: WithEnterpriseId): CommanderThunkAction =>
    (dispatch, _getState, { resolveRoute }) => {
        const query = {
            OwnerId: enterpriseId,
        };

        const url = resolveRoute(RouteName.EnterpriseIntegrationMarketplace, { query });

        dispatch(navigateInBaseModal(url));
    };
